import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';
import Select from 'react-select';
import PropTypes from 'prop-types';
import Checkbox from './../../../common/Checkbox';
var imm = require('immutable');


class Route extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            data: imm.Map({
                destcode : this.props.route.destcode,
                type : this.props.route.type,
                carriers : this.props.route.carriers.toString(),
                srcnumbers: this.props.route.srcnumbers.toString(),
                enabled : this.props.route.enabled
            })
        }
    }
    handleSelectChange(key, value) {
        if (value === null) {
            return;
        }
        var val = value.value;
        this.setState((state) => ({
            data: state.data.set(key, val)
        }), this.props.onChange(key, val));
    }
    handleMultiSelectChange(key, value) {
        if (value === null) {
            this.setState((state) => ({
                data: state.data.set(key, "")
            }), this.props.onChange(key, ""));
        } else {
            let newvals = ""
            for (var i = 0; i < value.length; i++) {
                newvals = newvals.concat(",", value[i].value)
            }
            this.setState((state) => ({
                data: state.data.set(key, newvals)
            }), this.props.onChange(key, newvals));
        }
    }
    handleChange(key, value) {
        this.setState((state) => ({
            data: state.data.set(key, value)
        }), this.props.onChange(key, value));
    }
    moveUp() {
        this.props.updn(-1);
    }
    moveDn() {
        this.props.updn(1);
    }
    onDelete() {
        this.props.onDelete();
    }
    render() {
        const {route, destinations, carriers, srcnumbers } = this.props;

        // normal select
        var opt_destinations = [];
        var valueDestinations = {value: 0, label: '--'};
        if (destinations !== undefined) {
            Object.keys(destinations).map(function (i) {
                opt_destinations.push({value: i, label: destinations[i]});
                if (i === this.state.data.get('destcode')) {
                    valueDestinations = {value: i, label: destinations[i]}
                }
            }, this);
        }

        // multiselect
        var opt_carriers = [];
        var valueCarriers = [];
        var vals = this.state.data.get('carriers').split(",");
        if (carriers !== undefined) {
            Object.keys(carriers).map(function (i) {
                opt_carriers.push({value: i, label: carriers[i]});
                if (vals !== undefined && vals.indexOf(i) >= 0) {
                    valueCarriers.push({value: i, label: carriers[i]})
                }
            }, this);
        }
        // multiselect
        var opt_srcnumbers = [];
        var valueSrcnumbers = [];
        var valssrc = this.state.data.get('srcnumbers').split(",");
        if (srcnumbers !== undefined) {
            Object.keys(srcnumbers).map(function (i) {
                opt_srcnumbers.push({value: i, label: srcnumbers[i]});
                if (vals !== undefined && valssrc.indexOf(i) >= 0) {
                    valueSrcnumbers.push({value: i, label: srcnumbers[i]})
                }
            }, this);
        }

        // normal select
        var opt_types = [ {value: 'roundrobin', label : 'Round Robin'},{ value: 'failover', label: 'Failover'}]
        var valueTypes = {value: 0, label: '--'};
        for (var i = 0; i < opt_types.length; i++) {
            if (opt_types[i].value === this.state.data.get('type')) {
                valueTypes = {value: opt_types[i].value, label: opt_types[i].label}
            }
        }

        return (
                <div className="panel-body route-item">
                    <div className="col-md-1">
                        <button 
                            className="btn btn-info" 
                            onClick = { this.moveUp.bind(this) } 
                            disabled = { this.props.first || !this.props.editmode } >
                                <span className="icon-up"> </span>
                        </button>
                        <button 
                            className="btn btn-info" 
                            onClick = { this.moveDn.bind(this) } 
                            disabled = { this.props.last || !this.props.editmode }>
                                <span className="icon-down"> </span>
                        </button>
                    </div>
                    <div className="col-md-2">
                        <Select
                            options={ opt_destinations }
                            id={'destcode'}
                            value={valueDestinations}
                            onChange={this.handleSelectChange.bind(this, 'destcode')}
                            isDisabled = { !this.props.editmode }
                        />
                    </div>
                    <div className="col-md-2">
                        <Select
                            options={ opt_srcnumbers }
                            id={'srcnumbers'}
                            value={valueSrcnumbers}
                            onChange={this.handleMultiSelectChange.bind(this, 'srcnumbers')}
                            isMulti
                            simpleValue
                            isDisabled = { !this.props.editmode }
                        />
                    </div>
                    <div className="col-md-2">
                        <Select
                            options={opt_types}
                            id={'type'}
                            value={valueTypes}
                            onChange={this.handleSelectChange.bind(this, 'type')}
                            isDisabled = { !this.props.editmode }
                            isClearable={false}
                        />
                    </div>
                    <div className="col-md-3">
                        <Select
                            options={ opt_carriers }
                            id={'carriers'}
                            value={valueCarriers}
                            onChange={this.handleMultiSelectChange.bind(this, 'carriers')}
                            isMulti
                            simpleValue
                            isDisabled = { !this.props.editmode }
                        />
                    </div>
                    <div className="col-md-1">
                        <Checkbox
                            label=''
                            checked={ this.state.data.get('enabled') }
                            className="form-control"
                            onChange={this.handleChange.bind(this, 'enabled')}
                            disabled = { !this.props.editmode }
                        />
                    </div>
                    <div className="col-md-1">
                        <button className="btn btn-danger"
                                onClick = { this.onDelete.bind(this) }
                                disabled = {!this.props.editmode }>
                            <span className="icon-trash"></span>&nbsp;Delete</button>
                    </div>
                </div>
        )
    }
}


const style = {
    border: '1px solid gray',
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'move',
};

const cardSource = {
    beginDrag(props) {
        return {
            id: props.id,
            index: props.index,
        };
    },
};

const cardTarget = {
    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Determine rectangle on screen
        const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        // Determine mouse position
        const clientOffset = monitor.getClientOffset();

        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%

        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }

        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }

        // Time to actually perform the action
        props.moveRoute(dragIndex, hoverIndex);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    },
};

// @DropTarget('card', cardTarget, connect => ({
//     connectDropTarget: connect.dropTarget(),
// }))
// @DragSource('card', cardSource, (connect, monitor) => ({
//     connectDragSource: connect.dragSource(),
//     isDragging: monitor.isDragging(),
// }))
export default class Card extends Component {
    // static propTypes = {
    //     connectDragSource: PropTypes.func.isRequired,
    //     connectDropTarget: PropTypes.func.isRequired,
    //     index: PropTypes.number.isRequired,
    //     isDragging: PropTypes.bool.isRequired,
    //     id: PropTypes.any.isRequired,
    //     moveRoute: PropTypes.func.isRequired,
    // };

    render() {
        const { text, isDragging, connectDragSource, connectDropTarget } = this.props;
        const opacity = isDragging ? 0 : 1;

        //return connectDragSource(connectDropTarget(
        return(    
            <div style={{ ...style, opacity }}>
                <Route
                    id =  {this.props.id}
                    route = { this.props.route }
                    index = { this.props.index }
                    destinations = { this.props.destinations }
                    carriers = { this.props.carriers }
                    srcnumbers = { this.props.srcnumbers }
                    updn = { this.props.updn }
                    first = { this.props.first }
                    last = { this.props.last }
                    onDelete = { this.props.onDelete }
                    editmode = { this.props.editmode }
                    onChange = { this.props.onChange }
                />
            </div>
        );
    }
}

// export default DragSource('card', cardSource, (connect, monitor) => ({
//     connectDragSource: connect.dragSource(),
//     isDragging: monitor.isDragging(),
// }))(Card)

// export default Card;